import { createFileRoute, notFound } from "@tanstack/react-router";

import BlogPostPage from "@/landing/blog/post-page";
import { buildPostHead } from "@/server-fns/blog/seo";
import { getBlogPostBySlugFn } from "@/server-fns/blog/serverFns";

export const Route = createFileRoute("/blog/$slug")({
    loader: async ({ params }) => {
        const result = await getBlogPostBySlugFn({ data: { slug: params.slug } });
        if (!result) {
            throw notFound();
        }
        return result;
    },
    head: ({ loaderData }) => (loaderData?.post ? buildPostHead(loaderData.post) : {}),
    component: RouteComponent,
});

function RouteComponent() {
    const { post, prev, next, related } = Route.useLoaderData();
    return <BlogPostPage post={post} prev={prev} next={next} related={related} />;
}
